import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { currentLocaleAtom } from './locale'
import { getTranslation, type TranslationKey } from './translations'

export function useTranslation() {
  const locale = useAtomValue(currentLocaleAtom)

  const t = useMemo(
    () => (key: TranslationKey) => getTranslation(locale, key),
    [locale]
  )

  return { t, locale }
}
